module.exports = __webpack_public_path__ + "static/media/chillennium.3bc906a5.jpg";